import * as React from 'react'

import { observer } from 'mobx-react'

import LocationCard from '../SitemapCards/LocationCard'
import MapViewItemBase from '../SitemapHelpers/models/MapViewItemBase'
import GeneralMapPopup from './GeneralMapPopup'

interface IProps {
  item: MapViewItemBase
  onPlusButtonClick?: () => void
  onClose(): void
  selectedStartDate?: Date
  selectedEndDate?: Date
  // Clearance from the marker, as GeneralMapPopup takes it.
  offset?: number
}

// localization: no text to translate

@observer
export default class LocationMapPopup extends React.Component<IProps> {
  public render() {
    const {
      onClose,
      item,
      selectedStartDate,
      selectedEndDate,
      onPlusButtonClick,
      offset,
    } = this.props

    return (
      <GeneralMapPopup
        item={item}
        onClose={onClose}
        customHeader={<></>}
        offset={offset}
        isOffsetCentred
      >
        <LocationCard
          item={item}
          onPlusButtonClick={onPlusButtonClick}
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
        />
      </GeneralMapPopup>
    )
  }
}
